'use client';

import Link from 'next/link';

// Utils
import { combineClasses } from '@shared/utils';

// Components
import { Typography } from '@shared/ui';
import { NavigationItem, NavigationVariant } from '@/components/NavigationItem';
import { InactiveEmployeeOverlay } from '@/components/InactiveEmployeeOverlay';

// Types
import { NavigationItemProps } from '@/types';
import ArrowLeftIcon from '@shared/icons/ArrowLeftIcon';
interface EmployeeNavigationProps {
  title: string;
  navItems?: NavigationItemProps[];
  className?: string;
  navigationBackHref?: string;
}
export const EmployeeNavigation = ({
  className,
  navItems,
  title,
  navigationBackHref
}: EmployeeNavigationProps) => <nav id="employee-navigation" data-testid="employee-navbar" className={combineClasses('bg-primary-700 relative', className)} data-sentry-component="EmployeeNavigation" data-sentry-source-file="index.tsx">
    <InactiveEmployeeOverlay data-sentry-element="InactiveEmployeeOverlay" data-sentry-source-file="index.tsx" />

    <div className={combineClasses('max-w-employee-page-content flex mx-auto w-full items-center justify-between relative', 'py-2 sm:py-3.5 px-4 sm:px-6 xl:px-0')}>
      <div className="flex gap-4 items-center">
        {navigationBackHref && <Link href={navigationBackHref}>
            <ArrowLeftIcon className="text-white" />
          </Link>}
        <Typography weight="light" className="text-lg lg:text-2xl text-white" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          {title}
        </Typography>
      </div>

      {/* Navigation items */}
      <div className="flex items-center gap-3 sm:gap-6.25">
        {navItems?.map(({
        href,
        icon
      }) => <NavigationItem key={href} icon={icon} href={href} variant={NavigationVariant.Employee} />)}
      </div>
    </div>
  </nav>;